export default __webpack_public_path__ + "static/media/dollar.d5d64110.svg";